declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

const getEnv = (key: string): string | undefined =>
  window._env_?.[key] ?? process.env[key];

export const FEATURE_FLAGS = {
  newUI: getEnv('REACT_APP_NEW_UI') === 'true',
};
